import React, { useState } from "react";
import { CharacterOutlineList, CharacterOutlineListProps } from "./CharacterOutlineList";
import { OutlineHeading } from "./OutlineHeading";
import { OutlineControls } from "./OutlineControls";
import { OutlineList } from "./OutlineList";
import "./Outline.css";

import type { OutlineControlsProps } from "./OutlineControls";
import type { OutlineHeadingProps } from "./OutlineHeading";
import type { OutlineListProps } from "./OutlineList";

export interface OutlineProps
  extends
    OutlineHeadingProps,
    Omit<OutlineControlsProps, "onCollapseAll" | "onExpandAll">,
    CharacterOutlineListProps,
    OutlineListProps {}

export function Outline(props: React.PropsWithChildren<Omit<OutlineProps, "expandAll">>) {
  const [expandAll, setExpandAll] = useState(false);

  return (
    <div className="outline">
      <OutlineHeading onChangeReviewMode={props.onChangeReviewMode} />
      <OutlineControls
        outlineSortMode={props.outlineSortMode}
        expandAll={expandAll}
        outlineMode={props.outlineMode}
        onCollapseAll={() => setExpandAll(false)}
        onExpandAll={() => setExpandAll(true)}
        onSelectOutlineSortMode={props.onSelectOutlineSortMode}
        onSelectOutlineMode={props.onSelectOutlineMode}
      />
      {props.outlineMode === "character" ? (
        <CharacterOutlineList
          characterStyles={props.characterStyles}
          expandAll={expandAll}
          outlineMode={props.outlineMode}
          selectedCharacterOriginFilter={props.selectedCharacterOriginFilter}
          selectedCharacterStyleFilter={props.selectedCharacterStyleFilter}
          styleDefinitionMap={props.styleDefinitionMap}
          styleGroups={props.styleGroups}
          onClearCharacterStyle={props.onClearCharacterStyle}
          onSelectCharacterStyle={props.onSelectCharacterStyle}
        />
      ) : (
        <OutlineList
          expandAll={expandAll}
          groups={props.groups}
          ignoreParagraphs={props.ignoreParagraphs}
          outlineMode={props.outlineMode}
          selectedBoundaryIndices={props.selectedBoundaryIndices}
          selectedGroupFilter={props.selectedGroupFilter}
          selectedStyleFilter={props.selectedStyleFilter}
          styleDefinitionMap={props.styleDefinitionMap}
          onClearGroup={props.onClearGroup}
          onClearStyle={props.onClearStyle}
          onSelectGroup={props.onSelectGroup}
          onSelectStyle={props.onSelectStyle}
          onSetBoundaryIndices={props.onSetBoundaryIndices}
        />
      )}
    </div>
  );
}
